import React, { Fragment } from "react";

interface Props {
  paragraph: string;
}

export default function ParagraphWithNewlines({ paragraph }: Props) {
  return (
    <>
      {paragraph
        ?.replaceAll("\r\n", "\n")
        .split("\n")
        .map((line: string, index: number) => (
          <Fragment key={index.toString()}>
            <p>{line}</p>
          </Fragment>
        ))}
    </>
  );
}
